import { createContext, useState } from "react";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";

import {
  ConfirmDialogContextType,
  ConfirmDialogOptions,
  ConfirmDialogProviderProps,
} from "interfaces";
export const ConfirmDialogContext = createContext<ConfirmDialogContextType>({
  showDialog: () => {},
  hideDialog: () => {},
});

export const ConfirmDialogProvider: React.FC<ConfirmDialogProviderProps> = ({
  children,
}) => {
  const [dialogVisible, setDialogVisible] = useState(false);
  const [modalClass, setModalClass] = useState<string | undefined>(undefined);
  const [, setDialogOptions] = useState<ConfirmDialogOptions | null>(null);

  const showDialog = (options: ConfirmDialogOptions) => {
    const {
      message,
      body,
      icon,
      defaultFocus,
      acceptClassName,
      rejectClassName,
      rejectLabel,
      acceptLabel,
      accept,
      reject,
      customFooter,
      dismissableMask,
      closable,
      modalClass,
      closeOnEscape,
    } = options;
    setModalClass(modalClass);

    const bodyMessage = () => {
      if (typeof message !== "string") {
        return (
          <>
            {message}
            {body && (
              <span className="label-regular d-block body"> {body}</span>
            )}
          </>
        );
      } else {
        const separateLines = message.split(/\n/g);
        return separateLines.map((line, index) => <p key={index}>{line}</p>);
      }
    };

    confirmDialog({
      message: bodyMessage,
      defaultFocus: defaultFocus,
      icon: icon,
      acceptClassName: acceptClassName,
      rejectClassName: rejectClassName,
      rejectLabel: rejectLabel,
      acceptLabel: acceptLabel,
      footer: customFooter,
      accept: () => {
        accept && accept();
        setDialogVisible(false);
      },
      reject: () => {
        reject && reject();
        setDialogVisible(false);
      },
      dismissableMask,
      closable,
      closeOnEscape,
    });

    setDialogOptions(options);
    setDialogVisible(true);
  };

  const hideDialog = () => {
    setDialogVisible(false);
  };

  return (
    <ConfirmDialogContext.Provider value={{ showDialog, hideDialog }}>
      {children}
      <ConfirmDialog
        id="confirm-dialog"
        className={`modal-sm ${modalClass}`}
        draggable={false}
        resizable={false}
        showHeader={false}
        visible={dialogVisible}
      />
    </ConfirmDialogContext.Provider>
  );
};
